import { environment } from "../../../environments/environment";
import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

/*
gt: verificare se un campo è maggiore di un valore costante
lt: verificare se un campo è minore di un valore costante
ge: verificare se un campo è maggiore o uguale a un valore costante
le: verificare se un campo è minore o uguale a un valore costante
*/
export const DettagliGiacenzeIniziali: AnaColumn[] = [

  {

    itemType: "group", caption: "Dettagli", colSpan: "4",
    data: [
      {
        type: 'campo', dataType: '', dataField: 'idMovimento', caption: 'Anno',
        maxLength: '4', defaultValue: null,
        colVisible: false, editorType: "dxTextBox", colWidth: '50', width: 9 + 'vw'
      },
      {
        defaultValue: null,
        type: 'campo', dataType: '', dataField: 'idRentri', caption: 'Anno',
        maxLength: '4',
        colVisible: false, editorType: "dxTextBox", colWidth: '50px', width: 9 + 'vw'
      },

      {
        type: 'campo', dataType: '', dataField: 'annoProtocolloGiacenza', caption: 'Anno',
        maxLength: '4',
        colVisible: true, editorType: "dxTextBox", colWidth: '50px', width: 9 + 'vw'
      },
      {
        type: 'campo', dataType: '', dataField: 'protocolloGiacenza', caption: 'Protocollo',
        maxLength: '6',
        colVisible: true, editorType: "dxTextBox", colWidth: "100px", width: 9 + 'vw'
      },

      {
        type: 'campo', dataType: '', dataField: 'formulario', caption: 'Formulario',
        maxLength: '14',
        colVisible: true, editorType: "dxTextBox", colWidth: '100px', width: 9 + 'vw'
      },
      {
        type: 'campoSpecial', colVisible: true,
        editorType: 'dxSelectBox',
        dataField: "idRegistro",
        caption: 'Registro',
        width: 12 + 'vw',
        placeHolder: '',
        lista: {
          dataSource: "RegistroRifiuti",
          valueExpr: 'id', displayExpr: 'descrizione',
          filter: '?$filter=(idSede eq $idDestinatario)',
          showClearButton: false,
        }
      },
      {
        type: 'campo', dataField: "quantitaKg", dataType: "number",
        caption: "Kg",
        colWidth: "100px",
        format: environment.PRECISION, colAlignment: 'right',
        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        maxLength: "11",
        colVisible: true,
        labelVisible: true,
        editorType: 'dxNumberBox',
      },
      {
        type: 'campo', dataField: "quantitaMc", dataType: "number",
        caption: "MC",
        format: environment.PRECISION, colAlignment: 'right',
        maxLength: "11",
        defaultValue: 0,
        colVisible: true,
        labelVisible: true,
        colWidth: "50px",
        editorType: 'dxNumberBox',
      },
      {
        type: 'campoSpecial', colVisible: true,
        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        editorType: 'dxSelectBox',
        dataField: "idTipoCarico",
        caption: 'Tipo Carico',

        placeHolder: '',
        lista: {
          dataSource: "tipoCarico",
          valueExpr: 'id', displayExpr: 'descrizione',
          showClearButton: false,
        }
      },
      {
        type: 'campo', dataField: "quantitaKgScaricata", dataType: "number", caption: "Kg Scaricati",
        format: environment.PRECISION, colAlignment: 'right',
        maxLength: "11",
        colVisible: true,
        labelVisible: true,
        disableOnUpdate: true,

        editorType: 'dxNumberBox',
        readonly: true,
        disabled: true
      },

    ]
  }
]